(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/results-common/assets/javascripts/parsers/parse-results.js') >= 0) return;  svs.modules.push('/components/numbergames/results-common/assets/javascripts/parsers/parse-results.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
let productMapping;
let parsePayout;
if (svs.isServer) {
  const path = require('path');
  parsePayout = require(path.join(__dirname, 'parse-payout.es6'));
  const trinidadCore = require('@svenskaspelab/trinidad-core').core;
  productMapping = trinidadCore.components.require('numbergames', 'product-mapping').productMapping;
} else {
  productMapping = svs.numbergames.productMapping;
  parsePayout = svs.numbergames.results_common.parsers.payout;
}
function parseResult() {
  var _parseProductResult$p;
  let result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const parseProductResult = {
    EUROJACKPOT: parseEurojackpotResult,
    KENO: parseKenoResult,
    JOKER: parseJokerResult,
    LOTTO: parseLottoResult,
    VIKINGLOTTO: parseVikingResult
  };
  const productId = productMapping.getProductId(result.productId);
  const parsedResult = ((_parseProductResult$p = parseProductResult[productId]) === null || _parseProductResult$p === void 0 ? void 0 : _parseProductResult$p.call(parseProductResult, result)) || result;
  return _objectSpread(_objectSpread({}, parsedResult), {}, {
    regCloseTime: result.regCloseTime,
    productDrawId: productMapping.getProductDrawId(result.productId),
    drawNumber: result.drawNumber,
    productId
  });
}
function parseEurojackpotResult(_ref) {
  let {
    drawResult,
    distribution,
    winningCountry
  } = _ref;
  if (Array.isArray(drawResult)) {
    const [{
      numbers
    }, {
      numbers: numbersExtra
    }] = drawResult;
    return {
      winningCountry,
      correctRow: {
        numbers,
        numbersExtra
      },
      payout: {
        productId: productMapping.CONSTANTS.EUROJACKPOT,
        distribution: parsePayout.parseInternationalDistribution(...distribution)
      }
    };
  }
}
function parseKenoResult(_ref2) {
  let {
    numbers,
    kungKenoNumber = [],
    distributionRegular,
    distributionKungKeno,
    totalPayout,
    totalWinners,
    topWin
  } = _ref2;
  if (Array.isArray(distributionRegular) && Array.isArray(distributionKungKeno)) {
    const productId = 'KENO';
    distributionRegular = distributionRegular.map(dist => _objectSpread(_objectSpread({}, dist), {}, {
      productId,
      payoutType: 'regular',
      type: dist.id
    }));
    distributionKungKeno = distributionKungKeno.map(dist => _objectSpread(_objectSpread({}, dist), {}, {
      productId,
      payoutType: 'extra',
      type: dist.id
    }));
    return {
      correctRow: {
        numbers,
        kungKenoNumber: kungKenoNumber[0]
      },
      payouts: distributionRegular.concat(distributionKungKeno),
      totalPayout,
      totalWinners,
      topWin
    };
  }
}
function parseJokerResult(_ref3) {
  let {
    drawResult = {},
    distribution
  } = _ref3;
  return {
    correctRow: {
      numbers: drawResult.numbers
    },
    payout: {
      distribution
    }
  };
}
function parseLottoResult(result) {
  return {
    lotto1: getLottoResultByType(1, result),
    lotto2: getLottoResultByType(2, result)
  };
}
function getLottoResultByType(type, _ref4) {
  let {
    drawResult,
    distribution
  } = _ref4;
  if (Array.isArray(drawResult) && Array.isArray(distribution)) {
    const dist = distribution.find(dist => dist.type === type);
    const {
      drawNumbers
    } = drawResult.find(drawRes => drawRes.type === type);
    const [{
      numbers
    }, {
      numbers: numbersExtra
    }] = drawNumbers;
    return {
      type,
      correctRow: {
        numbers,
        numbersExtra
      },
      payout: _objectSpread({
        productId: productMapping.CONSTANTS.LOTTO,
        type
      }, parsePayout.parseLottoPayout({
        distribution: dist.distribution,
        millionRain: distribution.find(dist => dist.type === type + 2)
      }))
    };
  }
}
function parseVikingResult(_ref5) {
  let {
    drawResult,
    distribution,
    winningCountries
  } = _ref5;
  if (Array.isArray(drawResult) && Array.isArray(drawResult[0].drawNumbers)) {
    const [{
      numbers
    }, {
      numbers: numbersExtra
    }] = drawResult[0].drawNumbers;
    return {
      winningCountries,
      correctRow: {
        numbers,
        numbersExtra
      },
      payout: {
        productId: productMapping.CONSTANTS.VIKINGLOTTO,
        distribution: parsePayout.parseInternationalDistribution(...distribution)
      }
    };
  }
}
if (svs.isServer) {
  module.exports = {
    parseResult
  };
} else {
  svs.numbergames.results_common.parsers.results = {
    parseResult
  };
}

 })(window);